// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width: 960px){#menu-parent_folder,#menu-selected_groups{position:absolute}}\n", ""]);
// Exports
module.exports = exports;
